export function getPreviousSunday(
  date: Date | null,
  weekOffset: number = 0
): Date {
  const baseDate = date ? new Date(date) : new Date();
  const sunday = new Date(baseDate);
  sunday.setDate(baseDate.getDate() - baseDate.getDay() + weekOffset * 7);
  sunday.setHours(0, 0, 0, 0);
  return sunday;
}

export function getNextSaturday(
  date: Date | null,
  weekOffset: number = 0
): Date {
  let newDate = !date ? new Date() : date;
  const nextSaturday = new Date(newDate);
  nextSaturday.setDate(
    newDate.getDate() - newDate.getDay() + 6 + weekOffset * 7
  );
  nextSaturday.setHours(0, 0, 0, 0);
  return nextSaturday;
}

export function formatBytes(bytes: number) {
  const units = ["B", "KB", "MB", "GB", "TB", "PB"];

  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }
  return `${value.toFixed(1)}${units[unitIndex]}`;
}

export function timeout(delay: number): Promise<number> {
  return new Promise((res) => setTimeout(res, delay));
}

export async function errorTreatment(
  e: unknown,
  handleLogout: () => Promise<void>
): Promise<boolean> {
  if (
    e &&
    typeof e === "object" &&
    "response" in e &&
    e.response &&
    typeof e.response === "object" &&
    "status" in e.response
    // e.response.status === 401
  ) {
    await handleLogout();
    alert(`Unauthorized - Logging out. error code: ${e.response.status}`);
    return false;
  }
  return true;
}
export function getUserInitials(userName: string): string {
  if (!userName || typeof userName !== "string") {
    return "";
  }

  const words = userName.trim().split(/\s+/);
  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

  return initials;
}
